import { Pagination, Stack } from '@mui/material';

interface NotificationPaginationProps {
  paginationSelected: number;
  setPagination: (page: number) => void;
  totalCount: number;
}

const NotificationPagination = ({ paginationSelected, setPagination, totalCount }: NotificationPaginationProps) => {
  const pageCounter = Math.max(Math.ceil(totalCount / 10), 1);

  return (
    <Stack spacing={2} alignItems="center" marginTop={2}>
      <Pagination
        count={pageCounter}
        page={paginationSelected}
        onChange={(e, value) => setPagination(value)}
        color="primary"
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
      />
    </Stack>
  );
};

export default NotificationPagination;
